/**
 * Central ZAR (rand) display rules: dot decimal separator, en-US grouping.
 * Use for amounts; keep `en-ZA` on `Date`/`toLocaleDateString` where locale is for calendars, not currency digits.
 */

import { parseAmount } from "./convertNumbers";

/** Canonical zero display for R-prefixed balances and fallbacks. */
export const ZAR_RANDS_ZERO = "R 0.00";

export function formatZarNumberForDisplay(n) {
  if (!Number.isFinite(n)) {
    return "0.00";
  }
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatRandsDisplay(n) {
  return `R ${formatZarNumberForDisplay(n)}`;
}

/**
 * Chart / hero highlight: fewer fraction digits for large magnitudes.
 */
export function formatZarChartHighlight(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) {
    return null;
  }
  return v.toLocaleString("en-US", {
    maximumFractionDigits: v >= 100 ? 0 : 2,
  });
}

export function formatMongoDecimalToZar(v) {
  if (v == null) {
    return ZAR_RANDS_ZERO;
  }
  if (typeof v === "object" && v !== null && "$numberDecimal" in v) {
    const s = String(v.$numberDecimal);
    const n = parseFloat(s);
    if (Number.isFinite(n)) {
      return `R ${formatZarNumberForDisplay(n)}`;
    }
    return s;
  }
  return String(v);
}

/**
 * API often returns ZAR as "R 100,00". Normalize to "R 100.00" for UI.
 * Leaves crypto strings like "0.60 USDT" unchanged.
 */
export function formatBusinessTxAmountDisplay(value) {
  if (value == null) {
    return "";
  }
  const s = String(value).trim();
  if (!s) {
    return s;
  }
  if (/^R[\s\u00a0]/i.test(s)) {
    const n = parseAmount(s);
    if (Number.isFinite(n)) {
      return `R ${formatZarNumberForDisplay(n)}`;
    }
  }
  return s;
}
